import { useMemo, useRef } from 'react';
import _ from 'lodash';
import useSearchParams from '@hyper-origin/use-search-params';

/**
 * 从 url search 获取请求参数
 * - sort 为 orderColumn-orderType
 */
function useURLQueryParams(
  transform?: (
    searchParams: URLSearchParams,
    query: hypers.REST.QueryParams & { [key: string]: any }
  ) => any,
  deps: any[] = []
): hypers.REST.QueryParams & { pageSize: number } {
  const transformRef = useRef(transform);
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const [orderColumn, orderType] = (searchParams.get('sort') ?? '').split('-') as any;
    const query = _.pickBy(
      {
        orderColumn,
        orderType,
        page: +(searchParams.get('page') ?? 1),
        // 这里不太符合 REST API v2，但是后端只支持这个
        pageSize: +(searchParams.get('pageSize') ?? 30),
        search: searchParams.get('search') ?? undefined,
      },
      _.identity
    );

    return transformRef.current ? transformRef.current(searchParams, { ...query }) : query;
  }, [transformRef.current, searchParams, ...deps]);
}

export default useURLQueryParams;
